import { useTranslation } from "react-i18next";
import { AllBeaconsTable } from "../../components/BeaconTable";

export function Beacons() {
  const { t } = useTranslation();
  return <AllBeaconsTable showConfigureButtons showFilter context="/beacons" />;
}
